import { ReactComponent as MailSVG } from '../../../assets/image/mail.svg';

const MailIcon = () => (
  <MailSVG height={40} style={{ marginLeft: 13, marginRight: 20 }} />
);

export default MailIcon;
